import React, { useState } from 'react';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import TreeToppingGroupElement from './TreeToppingGroupElement';
import TreeToppingElement from './TreeToppingElement';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ManageToppingGroup from '../../../../../components/ManageToppingGroup';
import ManageTopping from '../../../../../components/ManageTopping';
import RepositionToppings from './RepositionToppings';
import ReactModal from '../../../../../components/ReactModal';
import { COLORS } from '../../../../../utils/colors';

const TreeToppingGroup = (props) => {
  const { toppingGroup, expanded, setExpanded } = props;
  const [toppingGroupModalIsOpen, setToppingGroupModalIsOpen] = useState(false);
  const [toppingModalIsOpen, setToppingModalIsOpen] = useState(false);
  const [toppingGroupRepositionModalIsOpen, setToppingGroupRepositionModalIsOpen] = useState(false);

  const handleRepositionToppings = (e) => {
    e.stopPropagation();
    setExpanded({ toppings: true });
    setToppingGroupRepositionModalIsOpen(true);
  };

  const handleEditToppingGroup = (e) => {
    e.stopPropagation();
    setExpanded({ toppings: true });
    setToppingGroupModalIsOpen(true);
  };

  const handleAddTopping = (e) => {
    e.stopPropagation();
    setExpanded({ toppings: true });
    setToppingModalIsOpen(true);
  };

  const smallWindow = window.innerWidth < 500;

  return (
    <div style={{ position: 'relative', marginLeft: '-20px' }}>
      <TreeItem
        key={toppingGroup.id}
        nodeId={toppingGroup.id}
        label={
          <TreeToppingGroupElement
            toppingGroup={toppingGroup}
            expanded={expanded[toppingGroup.id]}
          />
        }
        style={{ margin: '16px 0' }}
        onClick={() => {
          const newExpanded = { ...expanded };
          newExpanded[toppingGroup.id] = !expanded[toppingGroup.id];
          setExpanded(newExpanded);
        }}
      >
        {toppingGroup.toppings &&
          toppingGroup.toppings.map((topping) => {
            const nodeId = `${topping.id}-${toppingGroup.id}`;
            return (
              <TreeItem
                key={topping.id}
                nodeId={nodeId}
                label={
                  <TreeToppingElement topping={topping} fromToppingGroupId={toppingGroup.id} />
                }
                style={{ margin: '8px 0px 8px 8px' }}
              />
            );
          })}
      </TreeItem>
      {expanded[toppingGroup.id] && (
        <div
          style={{
            position: 'absolute',
            top: smallWindow ? -15 : 15,
            right: smallWindow ? -15 : 15,
          }}
        >
          <FormatListNumberedIcon
            className="s-24-i txt-info pl-16 pr-8"
            onClick={handleRepositionToppings}
          />
          <EditIcon className="s-24-i txt-info pl-8 pr-8" onClick={handleEditToppingGroup} />
          <AddCircleIcon className="s-24-i txt-info pl-8 pr-8" onClick={handleAddTopping} />
        </div>
      )}
      {toppingGroupModalIsOpen && (
        <ReactModal modalIsOpen={toppingGroupModalIsOpen} setIsOpen={setToppingGroupModalIsOpen}>
          <ManageToppingGroup
            type="edit"
            toppingGroupId={toppingGroup.id}
            onClose={(e) => setToppingGroupModalIsOpen(false)}
          />
        </ReactModal>
      )}
      {toppingModalIsOpen && (
        <ReactModal modalIsOpen={toppingModalIsOpen} setIsOpen={setToppingModalIsOpen}>
          <ManageTopping
            type="new"
            toppingId="new"
            toppingGroupId={toppingGroup.id}
            onClose={() => setToppingModalIsOpen(false)}
          />
        </ReactModal>
      )}
      {toppingGroupRepositionModalIsOpen && (
        <ReactModal
          modalIsOpen={toppingGroupRepositionModalIsOpen}
          setIsOpen={setToppingGroupRepositionModalIsOpen}
        >
          <RepositionToppings
            toppingGroup={toppingGroup}
            close={() => setToppingGroupRepositionModalIsOpen(false)}
          />
        </ReactModal>
      )}
    </div>
  );
};

export default TreeToppingGroup;
